export class PostMessageService {
  private static iframe: HTMLIFrameElement | null = null;
  private static listeners: ((data: unknown) => void)[] = [];
  private static handler: ((e: MessageEvent) => void) | null = null;

  static setIframe(iframe: HTMLIFrameElement | null): void {
    this.iframe = iframe;
  }

  /** Send a partial config update to the game (fast path, no file write) */
  static sendConfigPatch(patch: Record<string, unknown>): void {
    this.send({ type: 'EDITOR_CONFIG_PATCH', patch });
  }

  /** Send a play command to the game */
  static sendPlayCommand(command: 'play' | 'pause' | 'stop' | 'spin'): void {
    this.send({ type: 'EDITOR_PLAY_COMMAND', command });
  }

  /** Request a screenshot from the game */
  static requestScreenshot(): void {
    this.send({ type: 'REQUEST_SCREENSHOT' });
  }

  /** Listen for messages from the game iframe */
  static listen(callback: (data: unknown) => void): () => void {
    if (!this.handler) {
      this.handler = (e: MessageEvent) => {
        if (e.origin !== 'http://localhost:8080') return;
        for (const cb of this.listeners) cb(e.data);
      };
      window.addEventListener('message', this.handler);
    }
    this.listeners.push(callback);
    return () => {
      this.listeners = this.listeners.filter(cb => cb !== callback);
      if (this.listeners.length === 0 && this.handler) {
        window.removeEventListener('message', this.handler);
        this.handler = null;
      }
    };
  }

  private static send(data: Record<string, unknown>): void {
    this.iframe?.contentWindow?.postMessage(data, 'http://localhost:8080');
  }
}
